module.exports = __webpack_public_path__ + "images/umcb21f63decb1770ce23830ab80e2bacca.png";